<script lang="ts" setup>
import Password, { type PasswordEmits, type PasswordProps } from 'primevue/Password'

interface Props extends /* @vue-ignore */ Omit<PasswordProps, 'fluid' | 'size'> {
  error?: boolean
}
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Emits extends /* @vue-ignore */ PasswordEmits {}
defineProps<Props>()
defineEmits<Emits>()

const model = defineModel<Props['modelValue'] | null>()

const errorInjected = inject<Ref<boolean>>('error', ref(false))
</script>

<template>
  <Password
    v-bind="$props"
    v-model="model"
    fluid
    :size="$viewport.isLessThan('md') ? 'small' : undefined"
    :invalid="errorInjected || error"
  />
</template>
